<script>
  export let className;
</script>

<button class="icon-button {className}">
  <slot />
</button>

<style>
  .icon-button {
    width: 46px;
    height: 46px;
    flex-shrink: 0;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    border: none;
    transition: 0.1s all;
    user-select: none;
    white-space: nowrap;
    outline: none;
  }
  .icon-button:disabled {
    background: var(--neutral-050);
  }
  .icon-button:disabled:hover {
    cursor: not-allowed;
  }
  .icon-button:disabled :global(svg path) {
    fill: var(--neutral-500);
  }
  .icon-button:focus-visible {
    box-shadow: 3px 3px 8px rgba(44, 61, 80, 0.16);
  }
  .icon-button:hover {
    cursor: pointer;
    background-color: var(--neutral-050);
  }

  .icon-button :global(.prev-slide) {
    margin-right: 12px;
  }

  .icon-button :global(.next-slide) {
    margin-left: 12px;
  }
</style>
